// extracted by mini-css-extract-plugin
export var bottom = "menu-module--bottom--d5e55";
export var burger = "menu-module--burger--78387";
export var extra = "menu-module--extra--44beb";
export var isOpen = "menu-module--isOpen--e578c";
export var middle = "menu-module--middle--a1f0e";
export var root = "menu-module--root--e81d2";
export var top = "menu-module--top--7e885";